import { useFormik } from 'formik';
import { FC } from 'react';
import { useSetDeliveryFeeMutation } from '../../../../store/shopping/api';
import { IFee } from '../../../../store/shopping/interface';
import { states } from '../../../../utils/nigeriaSates';
import { showErrorToast, showSuccessToast } from '../../../../utils/toast';
import { Container, CustomAddModal, CustomInput, DropDown } from './style';
import { addFeeValidation } from './validation';

type IAddFeeModal = {
  close: () => void;
  editItem: IFee | null;
};
export const AddFeeModal: FC<IAddFeeModal> = ({ close, editItem }) => {
  const [setDeliveryFee, { isLoading }] = useSetDeliveryFeeMutation();
  const handleAdd = (value: { state: string; fee: number }) => {
    setDeliveryFee(value)
      .unwrap()
      .then((res) => {
        showSuccessToast(res.message);
        close();
      })
      .catch((err) => {
        showErrorToast(err.message);
      });
  };
  const { values, errors, touched, setFieldValue, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        state: editItem?.state ?? '',
        fee: editItem?.fee ?? 0,
        serviceFee: editItem?.serviceFee ?? 0
      },
      validationSchema: addFeeValidation,
      onSubmit: handleAdd
    });
  return (
    <CustomAddModal
      btnClick={handleSubmit}
      btnTxt={'Add fee'}
      title={'Add fees'}
      disableBtn={isLoading}
      isLoading={isLoading}
      closeModal={close}
    >
      <Container>
        <DropDown
          value={values.state}
          errorMessage={touched.state ? errors.state : ''}
          onSelect={(value) => {
            setFieldValue('state', value);
          }}
          options={states}
          label="State"
        />
        <CustomInput
          onChange={handleChange('fee')}
          name="fee"
          placeholder="enter amount"
          min={0}
          value={values.fee}
          errorMessage={touched.fee ? errors.fee : ''}
          type={'number'}
          labelText="Amount"
        />
        <CustomInput
          onChange={handleChange('serviceFee')}
          name="serviceFee"
          placeholder="enter amount"
          min={0}
          value={values.serviceFee}
          errorMessage={touched.serviceFee ? errors.serviceFee : ''}
          type={'number'}
          labelText="Service Fee"
        />
      </Container>
    </CustomAddModal>
  );
};
